import {Luminous, LuminousGallery} from 'luminous-lightbox';

export default class Lightbox {

  setup() {
    this.query_selector = '.image-container';

    this.box = null;

    this.lightbox_options = {
      sourceAttribute: "data-src",
      caption: null,
      openTrigger: "click",
      closeTrigger: "click",
      closeWithEscape: true,
      closeOnScroll: true,
      showCloseButton: true,
      // appendToNode: document.body,
      // appendToSelector: document.querySelector('#base'),
      appendToSelector: '#base',
      onOpen: null,
      onClose: null,
      injectBaseStyles: false
    };
    this.lightbox_gallery_options = {
      arrowNavigation: true
    };

    this.build_lightbox();
    document.addEventListener("content:changed", (e) => {
      this.reset_lightbox();
      this.build_lightbox();
    });

  }

  reset_lightbox() {
    if(this.box) {
      try {
        this.box.luminousInstances.forEach(instance => instance.destroy());
        this.box.destroy();
      } catch(e) {
        console.log(e);
      }
    }
  }

  build_lightbox() {

    const elements = document.querySelectorAll(this.query_selector);

    if(elements.length) {
      setImmediate(() => {
        this.box = new LuminousGallery(
          document.querySelectorAll(this.query_selector),
          this.lightbox_gallery_options,
          this.lightbox_options
        );
      })
    }
  }
}
